import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { errors } from '../constants'
import FilterProductsSelector from './FilterProductsSelector/FilterProductsSelector'
import { transactionTypes as constantsTransactionTypes } from './constants'
import * as Styles from './styles'

const TransactionTypeSection = ({
  transactionTypes = [],
  onChangeTransactionTypes,
  error,
  productTypes,
  selectedProductTypes,
  onChangeProductTypes,
  productCategories,
  selectedCategories,
  onChangeSelectedCategories,
  returnReasonsFiltering,
  availabilityMode,
  onChangeAvailabilityMode,
  tags,
  onChangeTags,
  matchCase,
  onChangeMatchCase,
}) => {
  const { t } = useTranslation()

  const handleChange = (value, checked) => {
    if (checked) {
      onChangeTransactionTypes([...transactionTypes, value])
    } else {
      onChangeTransactionTypes(transactionTypes.filter(type => type !== value))
    }
  }

  return (
    <Styles.Container id={errors.transactionTypes} error={errors.transactionTypes === error}>
      <Text type="titleS">{t('Disponibilidad')}</Text>
      <div>
        <Text type="bodyMRegular">{t('Disponible para')}</Text>
        <Styles.CheckboxContainer>
          {constantsTransactionTypes.map((transactionType, index) => (
            <Checkbox
              key={index}
              label={t(transactionType.label)}
              checked={transactionTypes.includes(transactionType.value)}
              onChange={e => handleChange(transactionType.value, e.target.checked)}
            />
          ))}
        </Styles.CheckboxContainer>
      </div>
      <FilterProductsSelector
        returnReasonsFiltering={returnReasonsFiltering}
        availabilityMode={availabilityMode}
        onChangeAvailabilityMode={onChangeAvailabilityMode}
        productTypes={productTypes || []}
        selectedProductTypes={selectedProductTypes}
        onChangeProductTypes={onChangeProductTypes}
        categories={productCategories || []}
        selectedCategories={selectedCategories}
        onChangeCategories={onChangeSelectedCategories}
        tags={tags}
        onChangeTags={onChangeTags}
        matchCase={matchCase}
        onChangeMatchCase={onChangeMatchCase}
      />
    </Styles.Container>
  )
}

export default TransactionTypeSection
